// DRF doğrulama hataları alan bazlı gelir ({ vehicle: ['...'] }); toast'ta ilk anlamlı mesajı göster.
const MESSAGE_FIELDS = ['message', 'detail', 'non_field_errors', 'vehicle', 'driver', 'factory'];

const getErrorData = (error: unknown) =>
  (error as { response?: { data?: unknown } } | null)?.response?.data;

/** Hata değerindeki ilk metni bulur: 'mesaj', ['mesaj'] veya iç içe { username: ['mesaj'] }. */
const firstMessage = (value: unknown): string => {
  if (typeof value === 'string') {
    return value;
  }
  if (Array.isArray(value)) {
    return value.map(firstMessage).filter(Boolean).join(' ');
  }
  if (value && typeof value === 'object') {
    for (const nested of Object.values(value)) {
      const message = firstMessage(nested);
      if (message) {
        return message;
      }
    }
  }
  return '';
};

/** Backend'in alan bazlı doğrulama hatalarını Formik'in setErrors'ına uygun hale getirir. */
export const getApiFieldErrors = (error: unknown): Record<string, string> | null => {
  const data = getErrorData(error);
  if (!data || typeof data !== 'object') {
    return null;
  }
  const fieldErrors: Record<string, string> = {};
  Object.entries(data as Record<string, unknown>).forEach(([field, value]) => {
    fieldErrors[field] = firstMessage(value);
  });
  return fieldErrors;
};

export const getApiErrorMessage = (error: unknown, fallback: string): string => {
  const data = getErrorData(error) as Record<string, unknown> | undefined;
  if (!data || typeof data !== 'object') {
    return fallback;
  }
  for (const field of MESSAGE_FIELDS) {
    const message = firstMessage(data[field]);
    if (message) {
      return message;
    }
  }
  return firstMessage(data) || fallback;
};
